import { createCRUDHook } from './createCRUDHook';
import {
  CustomerDiscountDto,
  CustomerDiscountOrFixPriceDto,
} from 'utils/models';
import {
  GET_CUSTOMER_DISCOUNT_OR_PRICE,
  TBL_CUSTOMER_DISCOUNT,
} from './apiEndPoints';

interface CustomerDiscountCustomOperations {
  getCustomerDiscountOrPrice: (
    customerId: number,
    partIdList: string
  ) => Promise<CustomerDiscountOrFixPriceDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  CustomerDiscountDto,
  CustomerDiscountDto[],
  CustomerDiscountCustomOperations
>({
  entityName: 'CustomerDiscount',
  endpoint: TBL_CUSTOMER_DISCOUNT,

  customOperations: (auth) => ({
    getCustomerDiscountOrPrice: async (
      customerId: number,
      partIdList: string
    ): Promise<CustomerDiscountOrFixPriceDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_CUSTOMER_DISCOUNT +
            GET_CUSTOMER_DISCOUNT_OR_PRICE +
            `?customerId=${customerId}&partIdList=${partIdList}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CustomerDiscountContext = Context;
export const useCustomerDiscountManager = useManager;
export const useCustomerDiscount = useConsumer;
